import $axios from "../../api";
import FileSaver from "file-saver";

const state = {
  isLoading: false,
  createLoading: false,
  errors: "",
  isSuccess: false,
  levelList: [],
  logLevel: [],
  levelData: {},
  page: 1,
  viewAtk: null,
  atkProductList: [],
  atkRequestList: []
};

const mutations = {
  SET_LOADING(state, payload) {
    state.isLoading = payload;
  },
  SET_ERRORS(state, payload) {
    state.errors = payload;
  },
  SET_SUCCESS(state, payload) {
    state.isSuccess = payload;
  },
  SET_LEVEL_LIST(state, payload) {
    state.levelList = payload;
  },
  SET_LEVEL_DATA(state, payload) {
    state.levelData = payload;
  },
  SET_CREATE_LOAD(state, payload) {
    state.createLoading = payload;
  },
  SET_PAGE(state, payload) {
    state.page = payload;
  },
  SET_VIEW_ATK(state, payload) {
    state.viewAtk = payload;
  },
  SET_ATK_PRODUCT_LIST(state, payload) {
    state.atkProductList = payload;
  },
  SET_ATK_REQUEST_LIST(state, payload) {
    state.atkRequestList = payload;
  }
};

const actions = {
  listAtkRequest({ commit, state, rootState, dispatch }, payload) {
    commit("SET_LOADING", true);
    let url = `hr/atk/request/list`;
    let queryStr = url + payload;
    console.log(queryStr);
    // #
    return new Promise((resolve, reject) => {
      $axios
        .get(queryStr)
        .then((response) => {
          commit("SET_ATK_REQUEST_LIST", response.data.data);
          commit("SET_LOADING", false);
          resolve(response);
        })
        .catch((error) => {
          commit("SET_LOADING", false);
          dispatch('Main/globalSweetAlert', error.response, { root: true });
          reject(error);
        });
    });
  },
  updateAtkRequest({ commit, dispatch }, payload) {
    commit("SET_LOADING", true);
    return new Promise((resolve, reject) => {
      $axios
        .post('hr/atk/request/update', payload)
        .then((response) => {
          commit("SET_CREATE_LOAD", false);
          commit("SET_SUCCESS", true);
          commit("SET_LOADING", false);
          resolve(response);
        })
        .catch((error) => {
          commit("SET_CREATE_LOAD", false);
          commit("SET_ERRORS", error.response?.data?.errors);
          dispatch('Main/globalSweetAlert', error.response, { root: true });
          reject(error);
        });
    });
  },
  listAtkProduct({ commit, state, rootState, dispatch }, payload) {
    commit("SET_LOADING", true);
    let url = `hr/atk/product/list`;
    let queryStr = url + payload;
    console.log(queryStr);

    // #
    return new Promise((resolve, reject) => {
      $axios
        .get(queryStr)
        .then((response) => {
          commit("SET_ATK_PRODUCT_LIST", response.data.data);
          commit("SET_LOADING", false);
          resolve(response);
        })
        .catch((error) => {
          commit("SET_LOADING", false);
          dispatch('Main/globalSweetAlert', error.response, { root: true });
          reject(error);
        });
    });
  },
  atkProductCreate({ commit, dispatch }, payload) {
    // commit("SET_CREATE_LOAD", true);
    return new Promise((resolve, reject) => {
      $axios
        .post('hr/atk/product/create', payload)
        .then((response) => {
          commit("SET_CREATE_LOAD", false);
          commit("SET_SUCCESS", true);
          resolve(response);
        })
        .catch((error) => {
          commit("SET_CREATE_LOAD", false);
          commit("SET_ERRORS", error.response?.data?.errors);
          dispatch('Main/globalSweetAlert', error.response, { root: true });
          reject(error);
        });
    });
  },
  atkProductUpdate({ commit, dispatch }, payload) {
    commit("SET_CREATE_LOAD", true);
    return new Promise((resolve, reject) => {
      $axios
        .post('hr/atk/product/update', payload)
        .then((response) => {
          commit("SET_CREATE_LOAD", false);
          commit("SET_SUCCESS", true);
          resolve(response);
        })
        .catch((error) => {
          commit("SET_CREATE_LOAD", false);
          commit("SET_ERRORS", error.response?.data?.errors);
          dispatch('Main/globalSweetAlert', error.response, { root: true });
          reject(error);
        });
    });
  },
  atkProductView({ commit, dispatch }, payload) {
    commit("SET_CREATE_LOAD", true);
    let id = payload?.id
    let queryStr = 'hr/atk/product/view?id=' + id
    return new Promise((resolve, reject) => {
      $axios
        .get(queryStr)
        .then((response) => {
          commit("SET_CREATE_LOAD", false);
          commit("SET_VIEW_ATK", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          commit("SET_CREATE_LOAD", false);
          commit("SET_ERRORS", error.response?.data?.errors);
          dispatch('Main/globalSweetAlert', error.response, { root: true });
          reject(error);
        });
    });
  },
  atkProductDelete({ commit, dispatch }, payload) {
    commit("SET_CREATE_LOAD", true);
    return new Promise((resolve, reject) => {
      $axios
        .post('hr/atk/product/showhide', payload)
        .then((response) => {
          commit("SET_CREATE_LOAD", false);
          commit("SET_SUCCESS", true);
          resolve(response);
        })
        .catch((error) => {
          commit("SET_CREATE_LOAD", false);
          commit("SET_ERRORS", error.response?.data?.errors);
          dispatch('Main/globalSweetAlert', error.response, { root: true });
          reject(error);
        });
    });
  },
  exportExcel({ commit, state, rootState, dispatch }, payload) {
        commit("SET_LOADING", true);
    let url = `hr/atk/request/exports`;
    console.log(url, payload);
    try {
      $axios.get(url, {
        params: payload,
        responseType: 'blob'
      }).then((response) => {
        let fileName = 'atk_request_' + new Date().toISOString().split('T')[0] + '.xlsx';
        const contentDisposition = response.headers['content-disposition']
        if (contentDisposition) {
          const fileNameMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
          if (fileNameMatch && fileNameMatch[1]) {
            fileName = fileNameMatch[1].replace(/['"]/g, '');
          }
        }
        
        const url = window.URL.createObjectURL(new Blob([response.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        }));
        
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();

        window.URL.revokeObjectURL(url);
        document.body.removeChild(link);
        commit("SET_LOADING", false);
      }).catch((error) => {
        dispatch("Main/globalSweetAlert", error.response, { root: true });
        commit("SET_LOADING", false);
      });
    } catch (error) {
      dispatch("Main/globalSweetAlert", error.response, { root: true });
      commit("SET_LOADING", false);
    }
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
